'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './e-form-browser.routes';

export class EFormBrowserComponent {
  constructor(EFormsService, Auth, $state, dialogs, $stateParams, $uibModal, EFormResultsService, $scope, $filter) {
    'ngInject';
    this.EFormsService = EFormsService;
    this.EFormResultsService = EFormResultsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.eFormId = $stateParams.id;
    this.model = {};
    this.$filter = $filter;

    this.cursor = 0;
    this.maxCursor = 0;

    this.data = [];

    this.systemFormSchemas = {
      "contact": {
        "required" : [],
        "properties" : {
          "firstName" : {
            "type" : "string",
            "key" : "firstName",
            "title" : "First Name"
          },
          "lastName" : {
            "type" : "string",
            "key" : "lastName",
            "title" : "Last Name"
          },
          "email" : {
            "type" : "string",
            "key" : "email",
            "title" : "Email"
          },
          "phone" : {
            "type" : "string",
            "key" : "phone",
            "title" : "Phone"
          },
          "message" : {
            "x-schema-form" : {
              "type" : "textarea"
            },
            "type" : "string",
            "key" : "message",
            "title" : "Your Message"
          }
        },
        "type" : "object"
      },
      "feedback": {
        "required" : [],
        "properties" : {
          "name" : {
            "type" : "string",
            "key" : "name",
            "title" : "Name"
          },
          "email" : {
            "type" : "string",
            "key" : "email",
            "title" : "Email"
          },
          "feedback" : {
            "x-schema-form" : {
              "type" : "textarea"
            },
            "type" : "string",
            "key" : "feedback",
            "title" : "Feedback"
          }
        },
        "type" : "object"
      }
    };

    this.systemFormFields = {
      "contact": [
        { "type" : "text", "title" : "First Name", "key" : "firstName" },
        { "type" : "text", "title" : "Last Name", "key" : "lastName" },
        { "type" : "text", "title" : "Email", "key" : "email" },
        { "type" : "text", "title" : "phone", "key" : "phone" },
        { "type" : "textbox", "title" : "Your Message", "key" : "message" }
        ],
      "feedback": [
        { "type" : "text", "title" : "Name", "key" : "name" },
        { "type" : "text","title":"Email","key":"email" },
        { "type" : "textbox", "title" : "Feedback", "key" : "feedback" }]
    };

    if (this.eFormId) {
      if (this.eFormId == 'contact' || this.eFormId == 'feedback') {

        this.schema = this.systemFormSchemas[this.eFormId];
        this.form = ["*"];
        this.title = this.eFormId + " Form";
        this.description = "Responses of the " + this.title;

        this.csvHeader = this.systemFormFields[this.eFormId].map(field => field.title);
        this.csvOrder = this.systemFormFields[this.eFormId].map(field => field.key);

        this.imgFields = [];

        this.EFormResultsService.getBySystemForm({name: this.eFormId}, data => {
          this.data = data.reverse();
          this.maxCursor = this.data.length ? this.data.length - 1 : 0;
          this.move("first");
        });
      } else {
        this.EFormsService.get({id: this.eFormId}, form => {
          this.schema = form.formSchema;
          this.form = ["*"];
          this.title = form.name;
          this.description = form.description;
          this.signatureRequired = form.signatureRequired;

          this.csvHeader = form.fields.map(field => field.title);
          this.csvOrder = form.fields.map(field => field.key);

          this.imgFields = form.fields.filter(field => field.type == 'image');
          this.imgFields.forEach(field => {
            let key = field.key;
            let ppty = this.schema.properties[key];
            ppty.type = 'string';
            delete ppty.format;
            ppty["x-schema-form"].type = 'help';
            ppty["x-schema-form"].helpvalue = "";
          });

          this.EFormResultsService.getByForm({id: this.eFormId}, data => {
            this.data = data.reverse();
            this.maxCursor = this.data.length ? this.data.length - 1 : 0;
            this.move("first");
          });
        }, _ => {
          console.log("Could not load e-form schema from server");
          this.formNotFound = true;
        });
      }
    }
  }

  loadCsvData() {
    return this.data.map(response => response.data);
  }

  delete() {
    var that = this;

    var eformText = "<b>"+ this.$filter('date')(this.model.meta.creationDate,'MMM d, y h:mm a') + "</b>";
    var dlg = this.dialogs.confirm("Delete E-Form Response?", "Do you really want to delete the e-form response dated " + eformText + "?");
    dlg.result.then(() => {

      that.EFormResultsService.delete({id: this.model._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== that.model._id;
          });

          that.maxCursor--;
          this.move("first");
        },
        err => {
          alert("Could not delete e-form response");
        });

      }, () => {
        // Cancel
      });

  }

  move(pos) {
    switch (pos) {
      case 'first':
        this.cursor = 0;
        break;
      case 'prev':
        this.cursor--;
        break;
      case 'next':
        this.cursor++;
        break;
      case 'last':
        this.cursor = this.maxCursor;
        break;
    }

    this.model = this.data[this.cursor];

    if (this.imgFields.length) {
      this.imgFields.forEach(field => {
        let key = field.key;
        let label = "<label class='control-label'>"+this.schema.properties[key].title+"</label><br/>";
        let value = "-";

        if (this.model.data[key]) {
          let imgPath = "/api/storage/"+this.model.data[key];
          value = "<a target='_blank' href='"+imgPath+"'><img src='"+imgPath+"/thumb' /></a><br/><span style='font-weight:normal;font-size:x-small'>(Preview - Click to enlarge)</span>";
        }

        this.schema.properties[key]["x-schema-form"].helpvalue = label + value;
      });

      this.$scope.$broadcast('schemaFormRedraw');
    }
  }
}

export default angular.module('conduu.eForms.eFormBrowser', [uiRouter])
  .config(routes)
  .component('eFormBrowser', {
    template: require('./e-form-browser.html'),
    controller: EFormBrowserComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/browser/e-form-browser.component.js